import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Exchange() {
  const [loading, setLoading] = useState(true);
  const [prices, setPrices] = useState([]);
  const [headerHeight, setHeaderHeight] = useState();

  useEffect(() => {
    const header = document.getElementById('header');
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let tries = 0;
      while (tries < 5) {
        try {
          const response = await axios.get('https://dolarapi.com/v1/dolares');
          setPrices(response.data);
          setLoading(false);
          break; // Break out of the loop if successful response
        } catch (error) {
          tries++;
          console.log(`Error fetching data. Try ${tries}`);
          if (tries === 5) {
            console.log('Max tries reached. Unable to fetch data.');
            setLoading(false);
          }
        }
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const dateTime = new Date(dateString);
    return `${dateTime.toLocaleDateString()}, ${dateTime.toLocaleTimeString()}`;
  };

  return (
    <div style={{ paddingTop: headerHeight }}>
      {loading ? (
        <div>
          <p>Cargando...</p>
        </div>
      ) : (
        <div className="flex flex-col sm:grid sm:grid-cols-3  gap-5 py-5 px-10 sm:px-44">
          {prices.map((price, index) => (
            <div
              key={index}
              className="border border-[#34345c] bg-[#d6daf0] rounded-md flex flex-col justify-between"
            >
              <div className="p-3 flex justify-around items-center">
                <p className="flex justify-center text-[#34345c] text-xl font-bold">
                  Dólar {price['nombre'].toUpperCase()}
                </p>
              </div>
              <div className="flex justify-center gap-5 border-t border-b border-dotted border-[#34345c] py-3">
                <div className="flex flex-col items-center">
                  <p className="text-[#34345c] text-3xl font-bold">
                    {price['compra']}
                  </p>
                  <p className="text-[#34345c] text-lg font-bold">COMPRA</p>
                </div>
                <div>
                  <p className="text-[#34345c] text-3xl font-bold">
                    {price['venta']}
                  </p>
                  <p className="text-[#34345c] text-lg font-bold">VENTA</p>
                </div>
              </div>
              <div className="flex flex-col items-center py-3">
                <p className="text-[#34345c]">Última actualización:</p>
                <p className="text-[#34345c]">{`${formatDate(
                  price['fechaActualizacion']
                )}`}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Exchange;
